let Dispatcher = require("../dispatcher/dispatcher").default;
let DownloadStore = require("../stores/downloadstore").default;
let React = require("react");
let SplitButton = require("./splitbutton").default;

// New Imports
import * as actions from "../../actions/actions";
import { connect } from "react-redux";

class Hero_Actions extends React.Component {
    componentDidMount() {
        DownloadStore.addListener("change", this.onBoundDownloadChange);
        DownloadStore.addListener("error", this.onBoundDownloadError);
    }

    componentWillUnmount() {
        DownloadStore.removeListener("change", this.onBoundDownloadChange);
        DownloadStore.removeListener("error", this.onBoundDownloadError);
    }

    constructor(props) {
        super(props);

        this.onBoundDownloadChange = this.onDownloadChange.bind(this);
        this.onBoundDownloadError = this.onDownloadError.bind(this);

        this.state = {
            downloadInProgress: false,
            downloadResult: null
        };
    }

    onDownloadError() {
        return this.setState({
            downloadStatus: DownloadStore.getCurrentStatus(),
            downloadResult: false
        });
    }

    onDownloadChange() {
        let downloadStatus;
        let icon;
        icon = DownloadStore.getAll()["pendingDownload"];
        downloadStatus = DownloadStore.getCurrentStatus();
        if (icon && icon.id === this.props.icon.id) {
            return this.setState({
                downloadStatus
            });
        }
    }

    onKitsClick(e) {
        return e.preventDefault();
    }

    render() {
        let downloadBtnState;
        let downloadButton;
        let icon;
        let share_text;
        let license;
        icon = this.props.icon;
        share_text = "Check out " + icon.term + " icon ";
        if (!icon.uploader === "") {
            share_text += "created by " + icon.uploader.name;
        }
        downloadBtnState = "initial";
        if (this.state.downloadStatus === "PROCESSING") {
            downloadBtnState = "processing";
        }
        if (this.state.downloadStatus === "SUCCESS") {
            downloadBtnState = "success";
        }
        if (this.state.downloadStatus === "FAILURE") {
            downloadBtnState = "failure";
        }

        if (icon.license_description === "public-domain") {
            license = (
                <span className="icon-license-container hover-context-container margin-l-m">
                    <a href="#" className="hover-context">
                        <i
                            className="ui_public-domain"
                            style={{ fontSize: "18px" }}
                        />
                    </a>
                    <div className="hover-context-box">
                        <p className="help-headline">
                            This icon is Public Domain
                        </p>
                        <p className="help-body-copy">
                            You may use it for any project, without having to
                            give credit to the icon’s creator.
                        </p>
                        <a
                            className="text-link"
                            href="https://creativecommons.org/publicdomain/zero/1.0/"
                            target="_blank"
                        >
                            Learn more
                        </a>
                    </div>
                </span>
            );
        } else {
            // If NounPro
            if (this.props.currentUser.has_premium_account) {
                license = (
                    <span className="icon-license-container hover-context-container margin-l-m">
                        <a href="#" className="hover-context">
                            <i className="ui_cc" style={{ fontSize: "18px" }} />
                        </a>
                        <div className="hover-context-box">
                            <p className="help-headline">
                                This icon is licensed as Creative Commons CCBY
                            </p>
                            <p className="help-body-copy">
                                But lucky you — as a NounPro member you get a
                                perpetual, worldwide, royalty–free license to
                                use it as many times as you wish, without having
                                to give credit to the icon's creator!
                            </p>
                            <a
                                className="text-link"
                                href="https://thenounproject.com/accounts/upgrade/"
                                target="_blank"
                            >
                                Learn more
                            </a>
                        </div>
                    </span>
                );
            } else {
                // not NounPro
                license = (
                    <span className="icon-license-container hover-context-container margin-l-m">
                        <a href="#" className="hover-context">
                            <i className="ui_cc" style={{ fontSize: "18px" }} />
                        </a>
                        <div className="hover-context-box">
                            <p className="help-headline">
                                This icon is licensed as Creative Commons CCBY
                            </p>
                            <p className="help-body-copy">
                                When using it for any project, you are required
                                to{" "}
                                <a
                                    href="https://thenounproject.zendesk.com/hc/en-us/articles/200509928-How-do-I-give-creators-credit-in-my-work-"
                                    target="_blank"
                                >
                                    give credit to the icon‘s creator
                                </a>{" "}
                                or purchase a royalty–free license.
                            </p>
                            <a
                                className="text-link"
                                href="https://creativecommons.org/licenses/by/3.0/us/legalcode"
                                target="_blank"
                            >
                                Learn more
                            </a>
                        </div>
                    </span>
                );
            }
        }

        downloadButton = (
            <SplitButton
                buttonState={downloadBtnState}
                color="blue"
                iconClass="ui_download"
                initialButtonText="Download"
                leftButtonText="SVG"
                rightButtonText="PNG"
                leftButtonCallback={this.props.download.bind(null, "svg")}
                rightButtonCallback={this.props.download.bind(null, "png")}
                resetState={this.resetDownloadState}
            />
        );

        return (
            <div className="hero-actions">
                {downloadButton} {license}
                <div className="kit-share-container">
                    <div className="kit-wrapper">
                        <a
                            href="#"
                            onClick={this.onKitsClick.bind(this)}
                            className="kit ui_kit"
                            data-icon-id={this.props.icon.id}
                        />
                        <div className="kit-container" />
                    </div>
                    <a
                        className="react-share ui_share margin-l-m"
                        href="#"
                        onClick={this.props.showShareModal.bind(this)}
                    />
                    <div
                        className="hover-context-container margin-l-m"
                        style={{ display: "inline-block" }}
                    >
                        <a className="hover-context ui_help">
                            <span className="visuallyhidden">
                                Get more help
                            </span>
                        </a>
                        <div className="hover-context-box on-left">
                            <p className="help-headline">
                                {gettext(
                                    "Download an icon to use in any project. Choose between PNG & SVG file types."
                                )}
                            </p>
                            <p className="help-body-copy">
                                <strong>PNG</strong>{" "}
                                {gettext(
                                    "are raster images that can be used anywhere you use a photo. They're best for use in mediums like presentations or wireframes. Pixelation may occur when scaling up."
                                )}
                            </p>
                            <p className="help-body-copy">
                                <strong>SVG</strong>{" "}
                                {gettext(
                                    "are vector images that are infinitely scalable so they never pixelate. They're best for use in mediums like print and websites."
                                )}
                            </p>
                            <a
                                className="text-link light"
                                target="_blank"
                                href="https://thenounproject.zendesk.com/hc/en-us/sections/200159763-Downloading-Icons-Purchases-Receipts"
                            >
                                Get more help
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    resetDownloadState() {
        Dispatcher.dispatch({
            actionType: "confirmDownload"
        });
    }
}

function mapStateToProps(state, ownProps) {
    let apiResponse = state.apiResponse,
        currentUser = state.user;

    return { apiResponse, currentUser };
}

module.exports = connect(mapStateToProps, {})(Hero_Actions);
